import React, { Component } from "react";
import Form from "react-jsonschema-form-bs4";
//Current version
import {
  schema as GeyserSchema,
  uiSchema as GeyseruiSchema
} from "wn-claims-shared/dist/schema/geyser-schema";
import {
  schema as PropertyLossSchema,
  uiSchema as PropertyLossuiSchema
} from "wn-claims-shared/dist/schema/property-loss-schema";
import {
  schema as PublicLiabilitySchema,
  uiSchema as PublicLiabilityuiSchema
} from "wn-claims-shared/dist/schema/public-liability-schema";
import {
  schema as VehicleLossSchema,
  uiSchema as VehicleLossuiSchema
} from "wn-claims-shared/dist/schema/vehicle-loss-schema";
import {
  schema as WindscreenSchema,
  uiSchema as WindscreenuiSchema
} from "wn-claims-shared/dist/schema/windscreen-schema";
import {
  schema as VehicleCollisionSchema,
  uiSchema as VehicleCollisionuiSchema
} from "wn-claims-shared/dist/schema/vehicle-collision-schema-readonly";
//Read Only
import {
  schema as GeyserSchemaRO,
  uiSchema as GeyseruiSchemaRO
} from "wn-claims-shared/dist/schema/geyser-schema-readonly";
import {
  schema as PropertyLossSchemaRO,
  uiSchema as PropertyLossuiSchemaRO
} from "wn-claims-shared/dist/schema/property-loss-schema-readonly";
import {
  schema as PublicLiabilitySchemaRO,
  uiSchema as PublicLiabilityuiSchemaRO
} from "wn-claims-shared/dist/schema/public-liability-schema-readonly";
import {
  schema as VehicleLossSchemaRO,
  uiSchema as VehicleLossuiSchemaRO
} from "wn-claims-shared/dist/schema/vehicle-loss-schema-readonly";
import {
  schema as WindscreenSchemaRO,
  uiSchema as WindscreenuiSchemaRO
} from "wn-claims-shared/dist/schema/windscreen-schema-readonly";
import {
  schema as VehicleCollisionSchemaRO,
  uiSchema as VehicleCollisionuiSchemaRO
} from "wn-claims-shared/dist/schema/vehicle-collision-schema-readonly";
//Previous version, before update in 2022
import {
  schema as GeyserSchemaOld,
  uiSchema as GeyseruiSchemaOld
} from "wn-claims-shared/dist/schema/geyser-schema-2021";
import {
  schema as PropertyLossSchemaOld,
  uiSchema as PropertyLossuiSchemaOld
} from "wn-claims-shared/dist/schema/property-loss-schema-2021";
import {
  schema as PublicLiabilitySchemaOld,
  uiSchema as PublicLiabilityuiSchemaOld
} from "wn-claims-shared/dist/schema/public-liability-schema-2021";
import {
  schema as VehicleLossSchemaOld,
  uiSchema as VehicleLossuiSchemaOld
} from "wn-claims-shared/dist/schema/vehicle-loss-schema-2021";
import {
  schema as WindscreenSchemaOld,
  uiSchema as WindscreenuiSchemaOld
} from "wn-claims-shared/dist/schema/windscreen-schema-2021";

import axios from "axios";
import { objectMap, logger, logFormEvent } from "../../utils/common";
import $ from "jquery";
import { saveAs } from "file-saver";
import config from "../../config";

const FileSaver = require("file-saver");
const uuidv4 = require("uuid/v4");

class Wizard extends Component {
  constructor(props) {
    super(props);
    logger(["readonly wiz"]);
    this.formErrCode = "";
    this.formErrBody = "";

    this.formData = { ...this.props.formData, ...this.props.selectFormData };
    logger(["this.formData", this.formData]);

    this.state = {
      step: 0,
      formData: this.formData,
      formStage: 0,
      saveTabs: []
    };

    let schema, uiSchema;
    if (this.formData.claimtypeCat){
      logger(["2022 form layout (New)"]);
      //load new forms
      switch (this.formData.claimtype) {
        case "Geyser":
          schema = GeyserSchemaRO;
          uiSchema = GeyseruiSchemaRO;
          break;
        case "Vehicle Stolen or Hijacked":
          schema = VehicleLossSchemaRO;
          uiSchema = VehicleLossuiSchemaRO;
          break;
        case "Accident Collision":
          schema = VehicleCollisionSchemaRO;
          uiSchema = VehicleCollisionuiSchemaRO;
          break;
        case "Motor Vehicle Windscreen":
          schema = WindscreenSchemaRO;
          uiSchema = WindscreenuiSchemaRO;
          break;
        case "Property Loss or Damage":
          schema = PropertyLossSchemaRO;
          uiSchema = PropertyLossuiSchemaRO;
          break;
        case "Public Liability":
          schema = PublicLiabilitySchemaRO;
          uiSchema = PublicLiabilityuiSchemaRO;
          break;
        default:
          schema = {};
          uiSchema = {};
          break;
      }
    } else {
      logger(["First form layout (Old)"]);
      //load old forms        
      switch (this.formData.claimtype) {
        case "Geyser":
          schema = GeyserSchemaOld;
          uiSchema = GeyseruiSchemaOld;
          break;
        case "Motor Vehicle Loss or Damage":
          schema = VehicleLossSchemaOld;
          uiSchema = VehicleLossuiSchemaOld;
          break;
        case "Motor Vehicle Windscreen":
          schema = WindscreenSchemaOld;
          uiSchema = WindscreenuiSchemaOld;
          break;
        case "Property Loss or Damage":
          schema = PropertyLossSchemaOld;
          uiSchema = PropertyLossuiSchemaOld;
          break;
        case "Public Liability":
          schema = PublicLiabilitySchemaOld;
          uiSchema = PublicLiabilityuiSchemaOld;
          break;
        default:
          schema = {};
          uiSchema = {};
          break;
      }
    }

    this.schemas = this.props.schemas ? this.props.schemas : [];
    this.uiSchemas = this.props.uiSchemas ? this.props.uiSchemas : [];
    logger(["this.schemas: ", this.schemas]);
    logger(["this.uiSchemas: ", this.uiSchemas]);
    const sTest = this.props.schemas ? "schemas defined" : "no schemas defined";
    logger(["sTest:", sTest]); // FIXME: remove
    this.readOnly = this.props.readOnly;
    this.btnSubmit = <span />;
    if (this.readOnly) {
      // TODO: duplicate call of objectMap, when not read only it is being called in the wrapping comp, pass info to here from parent and complete mapping here for all components
      objectMap(schema.properties, value => {
        this.schemas.push(value);
        this.uiSchemas.push(uiSchema);
      });
    }
    this.attachmentKeys = [
      // FIXME: find a better solution to hard coding attachment keys here (use a config file or flag with a custom type?)
      // Geyser
      "attachmentsList",
      // Group Personal
      "disablementDocCert",
      "disablementPercentageConfirmation",
      "disablementAppointmentLetter",
      "disablementMedReport",
      "disablementMedAccountsStatements",
      "disablementPolicePlan",
      "iodPostMortem",
      "iodInquestReport",
      "iodExecutorshipLetter",
      // Property Loss
      "itemsClaimedDocs",
      // Public Liability
      "claimsAttachment",
      // Vehicle Loss
      // TODO: add vehicle loss attachment keys
      "incidentReport",
      "descriptionSketch"
      // Windscreen
    ];
    logger(["Logger!"]);
    logger(["this.schemas: ", this.schemas]);
    logger(["this.uiSchemas: ", this.uiSchemas]);
    this.attachmentLinks = this.GenerateAttachmentLinks(this.formData);
    if (this.formData["claimtype"]) {
      this.updateTabsWithIncidentType(this.formData); // update tabs after form data loaded
    }
  }

  updateTabsWithIncidentType(data) {
    logger(["changes data: ", data]);
    const { claimtype } = data;
    logger(["incident type: ", claimtype]);
    console.log("incident type: ", claimtype);
    const saveTabs = this.state.saveTabs;
    if (
      claimtype === "Accident Collision" &&
      this.formData.thirdparty.thirdpartyInvolved == "No"
    ) {
      logger(["schemas pre slice: ", this.schemas]);
      if (this.schemas[6].title === "Third Party") {
        saveTabs.push(this.schemas[6]);
        saveTabs.push(this.schemas[7]);
        saveTabs.push(this.schemas[8]);
        this.schemas.splice(6, 3); // splice Third party tabs
        this.setState({
          ...this.state,
          saveTabs: saveTabs,
          formData: {
            ...this.state.formData
          }
        });
      }
      logger(["schemas post slice: ", this.schemas]);
      logger(["saved tabs", saveTabs]);
    } else if (
      claimtype === "Accident Collision" &&
      this.formData.thirdparty.thirdpartyInvolved == "Yes" &&
      this.formData.thirdparty.thirdpartyOther.thirdpartyHaveDetails == "No" 
    ) {
      if (this.schemas[6].title === "Third Party") {
        saveTabs.push(this.schemas[6]);
        saveTabs.push(this.schemas[7]);
        this.schemas.splice(6, 2); // splice Third party tabs
        this.setState({
          ...this.state,
          saveTabs: saveTabs,
          formData: {
            ...this.state.formData
          }
        });
      }
    }
  }

  ObjectFieldTemplate({ TitleField, properties, title, description }) {
    return (
      <div className="container">
        <TitleField title={title} />
        <div>{description}</div>
        <div className="row">
          {properties.map(prop => (
            <div className="col col-sm-6 left" key={prop.content.key}>
              {prop.content}
            </div>
          ))}
        </div>
      </div>
    );
  }
  // TODO: move to utils
  validateTelNumbers = (formData, errors) => {
    const phoneno = /^\d{10}$/;
    // FIXME: is it possible to use a universal telephone type to flag telephone number validations instead of hardcoding? if not move to a config file
    const telephoneKeys = ["brokertel", "brokerfax", "insuredtel", "insuredfax", "insuredcell"];
    logger(["formData", formData]);
    logger(["errors", errors]);
    telephoneKeys.forEach(element => {
      console.log(element);
      if (formData.hasOwnProperty(element) && formData[element]) {
        if (!formData[element].match(phoneno)) {
          errors[element].addError("Not a valid telephone number.");
        }
      }
    });
    return errors;
  };

  onSubmit = ({ formData }) => {
    if (this.state.step < this.schemas.length - 1) {
      const newstep = parseInt(this.state.step, 10) + 1;
      logger(["newstep:", newstep]);

      this.setState({
        ...this.state,
        step: newstep,
        formData: {
          ...this.state.formData,
          ...formData
        }
      });
    } else {
      if (!this.readOnly) {
        // Don't post if in readOnly mode
        this.setState({ formStage: 1 });
        this.postForm(formData);
      }
    }
  };
  // TODO: move to utils
  getBase64FileName = base64str => {
    let str = base64str;
    str = str.substr(str.indexOf("name=") + 5, str.lastIndexOf("base64,") - 27);
    return str;
  };
  // TODO: move to utils
  getAttachments = formData => {
    let attachments = [];
    this.attachmentKeys.forEach(function(key) {
      if (formData[key]) {
        formData[key].forEach(function(entry) {
          logger(["entry: ", entry]);
          let fName = entry;
          fName = fName.substr(fName.indexOf("name=") + 5, fName.lastIndexOf("base64,") - 27);
          fName = fName.replace(/[^a-zA-Z0-9]/g, "");
          logger(["file name:", fName]);
          logger(["attachment: ", key + ":", fName]);
          attachments = [
            ...attachments,
            {
              name: fName,
              content: entry
            }
          ];
        });
      }
    });

    return attachments;
  };

  GenerateAttachmentLinks = formData => {
    let attachmentLinks = [];
    this.attachmentKeys.forEach(key => {
      if (formData[key]) {
        formData[key].forEach(entry => {
          logger(["add attachment links entry", entry]);

          const fileContent = entry.attachment[1][0];

          if(fileContent[0]!="")
          {
          let fileName = fileContent
            .split("name=")
            .pop()
            .split(";base64")[0];
          
          fileName = fileName.split("%20").join(" ");
          const fileExtension = fileName.split(".").pop();
          const fileId = uuidv4();
          attachmentLinks.push({
            fileId: fileId,
            fileName: fileName,
            fileContent: fileContent,
            fileExtension: fileExtension
          });}
          console.log("attachmentLinks", attachmentLinks);
        });
      }
    });
    logger(["generate attachmentLinks data", attachmentLinks]);
    return attachmentLinks;
  };

  postForm = formData => {
    const hostname = window.location.hostname;
    let url = "";
    for (let host in config.hosts) {
      if (hostname == config.hosts[host].hostname) {
        console.log(`Running on ${host} environment.`);
        url = config.hosts[host].postFormEndpoint;
        console.log("setting Post Form API url to ", url);
      }
    }
    if (!url) {
      // set default url if not set
      console.warn("No valid Post Form API endpoint found in config. Setting to default.");
      url = config.hosts.default.postFormEndpoint;
    }
    console.log("URL", url);
    const concatData = { ...this.state.selectedForm, ...formData };
    const strData = JSON.stringify(concatData, null, 0);
    logger(["formData: ", formData]);
    logger(["concatData: ", concatData]);
    const ct = concatData.claimtype;
    const reg = concatData.region;

    let attachments = this.getAttachments(concatData);

    const data = {
      properties: {
        Form: strData,
        Claim: ct,
        Insured: concatData.insuredName,
        PolicyNo: concatData.insuredPolicyNumber,
        Region: reg,
        BrokerEmail: concatData.brokeremail,
        Attachments: attachments
      }
    };
    logger(["Data: ", concatData]);
    logger(["Post: ", data]);
    axios
      .post(url, data)
      .then(response => {
        logger(["Done: ", response]);
        this.setState({ selectedForm: {}, formStage: 2 }); // FIXME: not resetting state, keep ref of initial state instead
      })
      .catch(error => {
        logger(["Error: ", error]);
        this.formErrCode = error["response"]["status"];
        this.formErrBody = error["response"]["data"]["error"];
        this.setState({
          formErrCode: error["response"]["status"],
          formErrBody: error["response"]["data"]["error"]
        });
      });
  };

  onBack = ({ formData }) => {
    if (this.state.step > 0) {
      const newstep = this.state.step - 1;
      logger(["newstep:", newstep]);
      this.setState({
        ...this.state,
        step: newstep,
        formData: {
          ...this.state.formData,
          ...formData
        }
      });
    }
  };

  onStep = step => {
    if (step < this.state.step) {
      const newstep = step;
      logger(["tabstep:", newstep]);
      this.setState({
        step: newstep
      });
      logger(["new step-tab: ", this.state.step]);
    }
  };

  handleTabClick = k => {
    // Get clicked tab step number
    const step = k;
    // cancel if the clicked step is after current step,
    // ignore this rule in read-only mode
    if (!this.readOnly && k > this.state.step) return;
    logger(["goto step: ", k]);
    // change state step (triggers loading clicked tab)
    this.setState({
      ...this.state,
      step: step,
      formData: {
        ...this.state.formData
      }
    });
  };

  componentDidUpdate = () => {
    if (this.readOnly) {
      this.attachmentKeys.forEach(key => {
        if (this.state.formData[key]) {
          // hide attachment widget
          $(`#root_${key} .array-item .array-item-list .array-item:nth-child(2)`).hide();
          // hide buttons
          $(`#root_${key} .array-item-toolbox .btn-group`).hide();
          $(`#root_${key} .array-item-add`).hide();
          // append download button
          this.attachmentLinks.forEach((item, index) => {
            $(`#root_${key} .array-item:nth-child(${index + 1}) .array-item-toolbox`).append(
              `<a  id="${item.fileId}" title="${item.fileName}" class="btn btn-info btn-attachment-download">Download</a>`
            );
            $(`#${item.fileId}`).click(() => FileSaver.saveAs(item.fileContent, item.fileName));
          });
        }
      });
    }
  };

  navHome() {
    return (window.location.href = "/");
  }

  render() {
    let tabs = Object.keys(this.schemas).map(tab => (
      <div
        className={"nav-item active key-" + tab}
        key={"nav-item" + tab}
        onClick={() => this.handleTabClick(tab)}
        disabled={!this.readOnly ? (tab < this.state.step ? false : true) : false}
        style={{ cursor: "pointer" }}
      >
        <div
          className={
            "nav-link " +
            (tab == this.state.step ? " active show" : "") +
            (tab > this.state.step ? " disabled" : "") +
            (tab < this.state.step ? " completed" : "")
          }
        >
          {this.schemas[tab].title}
        </div>
      </div>
    ));

    let back, next;
    if (!this.readOnly) {
      // Normal view buttons
      if (this.state.step > 0) {
        back = (
          <button className="btn btn-primary" type="button" onClick={this.onBack}>
            Back
          </button>
        );
        next = (
          <button
            className="btn btn-primary"
            type="submit"
            style={{ boxShadow: "none !important" }}
          >
            {" "}
            {this.state.step < this.schemas.length - 1 ? "Next" : "Submit"}
          </button>
        );
      } else {
        back = (
          // FIXME: use router instead of window
          <a className="btn btn-primary" href="/">
            Back
          </a>
        );
        next = (
          <button
            className="btn btn-primary"
            type="submit"
            style={{ boxShadow: "none !important" }}
          >
            {" "}
            {this.state.step < this.schemas.length - 1 ? "Next" : "Submit"}
          </button>
        );
      }
    } else {
      // Set read-only buttons
      back = (
        <button className="btn btn-primary" type="button" onClick={this.navHome}>
          Close
        </button>
      );
      next = "";
    }
    let readOnlyHeader;
    if (this.readOnly) {
      readOnlyHeader = (
        <div>
          <h3>{this.formData.claimtype}</h3>
          <p>
            {"Policy Number: " + this.formData.insuredPolicyNumber}
            <br />
            {"Insured Name: " + this.formData.insuredName}
            <br />
            {"Region: " + this.formData.region}
          </p>
        </div>
      );
    }
    let form;
    if (this.formErrCode !== "") {
      // Form threw error
      form = (
        <div style={{ margin: "2em" }}>
          <h3>Error</h3>
          <h4>{this.formErrCode}</h4>
          <div>{this.formErrBody}</div>
        </div>
      );
    } else {
      // No error
      if (this.state.formStage == 0) {
        form = (
          <div style={{ margin: "2em" }}>
            <Form
              schema={this.schemas[this.state.step]}
              uiSchema={this.uiSchemas[this.state.step]}
              onSubmit={this.onSubmit}
              formData={this.state.formData}
              onChange={logFormEvent("changed")}
              onError={logFormEvent("errors")}
              showErrorList={false}
              disabled={this.readOnly}
              validate={this.validateTelNumbers}
            >
              <div style={{ margin: "2em" }}>
                {back}
                {/* //FIXME: remove inline styling */}
                {next}
              </div>
            </Form>
          </div>
        );
      } else if (this.state.formStage == 1) {
        // Posting form
        form = (
          <div style={{ margin: "2em" }}>
            <h3>Please Wait</h3>
            <div>Submitting claim..</div>
          </div>
        );
      } else if (this.state.formStage == 2) {
        // Successfully posted form
        // TODO: use ThankYou shared component instead
        form = (
          <div style={{ margin: "2em" }}>
            <h3>Thank You</h3>
            Your claim has been submitted.
            <br />
            <button className="btn btn-primary" onClick={this.navHome}>
              Finish
            </button>
          </div>
        );
      }
    }

    return (
      <div>
        {readOnlyHeader}
        <br />
        <div className="card shadow">
          <div className="nav nav-tabs card-header" style={{ padding: 0 }}>
            {tabs}
          </div>
          {form}
        </div>
      </div>
    );
  }
}

export default Wizard;
